import axios from 'axios';

const state = {
	user: null,
};

const getters = {
    isAuthenticated: state => !!state.user,
    StateUser: state => state.user,
};

const actions = {
    async setUser({ commit }, userData) 
    {
        await commit("setUser", userData);
    },
    async logout({ commit })
    {
        await commit("logout");
    }
};

const mutations = {
    setUser(state, userData) 
    {
        state.user = userData
    },
    logout(state) 
    {
        state.user = null
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};